import styled from 'styled-components';

import BodyTextBlock from '@carvana/showroom-content/TextBlock/Body';

export const StyledContainer = styled.div`
  max-width: 500px;
  margin-bottom: 40px;
`;

export const StyledMessage = styled(BodyTextBlock)`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.carvana.gray.dark};
`;

export const StyledQuery = styled.span`
  font-weight: bold;
`;